import React, { useState, useEffect } from 'react';
import './LandingPage.css';
import logo from './assets/10.png';
import heroIcon from './assets/9.png';

function LandingPage({ onStart, isLoggedIn, userName, onBackToUpload }) {
  const [activeService, setActiveService] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [copiedItem, setCopiedItem] = useState(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleServiceClick = (serviceKey) => {
    if (isMobile) {
      setActiveService(activeService === serviceKey ? null : serviceKey);
    }
  };

  const handleCloseDrawer = () => {
    setActiveService(null);
  };

  const handleStartClick = () => {
    if (isLoggedIn && onBackToUpload) {
      onBackToUpload();
    } else {
      onStart();
    }
  };

  const getButtonText = () => {
    if (isLoggedIn) {
      return `Передача файлов (${userName})`;
    }
    return 'Передача файлов';
  };

  const copyToClipboard = (text, item) => {
    navigator.clipboard.writeText(text);
    setCopiedItem(item);
    setTimeout(() => setCopiedItem(null), 1500);
  };

  const servicesData = {
    cadcam: {
      name: "CAD/CAM полный цикл",
      priceList: [
        { service: "Цирконий Multilayer", price: "2500 ₽" },
        { service: "Цирконий Multilayer на импл", price: "2800 ₽" },
        { service: "Циркониевый каркас", price: "1800 ₽" },
                { service: "Циркониевый каркас на импл", price: "2000 ₽" },
        { service: "Циркониевая вкладка", price: "1800 ₽" },
        { service: "Индивидуальный циркониевый абатмент", price: "1800 ₽" },
        { service: "Цирконий Multilayer ОТ ВОСКА", price: "1900 ₽" },
        { service: "Цирконий Multilayer на импл ОТ ВОСКА", price: "2200 ₽" },
        { service: "Циркониевая каркас ОТ ВОСКА", price: "1400 ₽" },
        { service: "Циркониевая вкладка ОТ ВОСКА", price: "1400 ₽" },
        { service: "Индивидуальный циркониевый абатм ОТ ВОСКА", price: "1400 ₽" },
        { service: "Циркониевый каркас на импл ОТ ВОСКА", price: "1700 ₽" },
        { service: "Воск", price: "900 ₽" },
        { service: "ПММА", price: "1000 ₽" },
        { service: "ПММА на импл", price: "1200 ₽" },
        { service: "Моделирование каркасов", price: "400 ₽" },
        { service: "Моделирование каркасов импл", price: "600 ₽" },
        { service: "Сканирование на культях", price: "100 ₽" },
        { service: "Сканирование на импл", price: "200 ₽" },
        { service: "Моделирование на ваксап", price: "600 ₽" }
      ]
    },
    milling: {
      name: "Фрезерование STL файлов",
      priceList: [
        { service: "Цирконий Multilayer с файлов STL", price: "1500 ₽" },
        { service: "Цирконий Multilayer на импл  с файлов STL", price: "1700 ₽" },
        { service: "Циркониевая вкладка с файлов STL", price: "1100 ₽" },
        { service: "Циркониевый каркас с файлов STL", price: "1100 ₽" },
        { service: "Индивидуальный циркониевый абатм с файлов STL", price: "1100 ₽" },
        { service: "ПММА с файлов STL", price: "500 ₽" },
        { service: "Воск  с файлов STL", price: "400 ₽" }
      ]
    },
    printing: {
      name: "3D печать",
      priceList: [
        { service: "Печатанная модель", price: "1000 ₽" },
        { service: "Печатанная модель импл", price: "1200 ₽" },
        { service: "Печатанная модель импл с файлов STL", price: "700 ₽" },
        { service: "Печатанная модель с файла STL", price: "500 ₽" }
      ]
    }
  };

  const getActiveServiceData = () => {
    if (activeService === 'cadcam') return servicesData.cadcam;
    if (activeService === 'milling') return servicesData.milling;
    if (activeService === 'printing') return servicesData.printing;
    return null;
  };

  return (
    <div className="landing">
      <header className="landing-header">
        <img src={logo} alt="Logo" className="landing-logo" />
        <div className="header-links">
          <div 
            onClick={() => copyToClipboard('+79782165328', 'phone1')}
            className={`header-link ${copiedItem === 'phone1' ? 'copied' : ''}`}
            style={{ cursor: 'pointer' }}
          >
            {copiedItem === 'phone1' ? '✓ Скопировано!' : '+7 (978) 216-53-28'}
          </div>
          <span className="header-separator">—</span>
          <div 
            onClick={() => copyToClipboard('+79784619011', 'phone2')}
            className={`header-link ${copiedItem === 'phone2' ? 'copied' : ''}`}
            style={{ cursor: 'pointer' }}
          >
            {copiedItem === 'phone2' ? '✓ Скопировано!' : '+7 (978) 461-90-11'}
          </div>
          <span className="header-separator">—</span>
          <div 
            onClick={() => copyToClipboard('edememraliev@mail.ru', 'email')}
            className={`header-link ${copiedItem === 'email' ? 'copied' : ''}`}
            style={{ cursor: 'pointer' }}
          >
            {copiedItem === 'email' ? '✓ Скопировано!' : 'edememraliev@mail.ru'}
          </div>
        </div>
      </header>

      <main className="landing-main">
        <section className="hero">
          <div className="hero-content">
            <div className="hero-badge">digital dental lab</div>
            <h1 className="hero-title">
              Цифровая<br />
              зуботехническая лаборатория<br />Эдема Эмралиева
            </h1>
            <button className="hero-btn desktop-btn" onClick={handleStartClick}>
              {getButtonText()}
              <span className="hero-btn-arrow">→</span>
            </button>
          </div>
          <div className="hero-image">
            <img src={heroIcon} alt="3D dental" className="hero-image-img" />
            <button className="hero-btn mobile-btn" onClick={handleStartClick}>
              {getButtonText()}
              <span className="hero-btn-arrow">→</span>
            </button>
          </div>
        </section>

        <section className="services">
          <div 
            className="service-item"
            onClick={() => handleServiceClick('cadcam')}
            onMouseEnter={() => !isMobile && setActiveService('cadcam')}
            onMouseLeave={() => !isMobile && setActiveService(null)}
          >
            <span className="service-number">01</span>
            <span className="service-name">CAD/CAM полный цикл</span>
            {!isMobile && (
              <div className="price-drawer">
                <div className="drawer-content">
                  <div className="drawer-list">
                    {servicesData.cadcam.priceList.map((item, idx) => (
                      <div key={idx} className="drawer-row">
                        <span className="drawer-service">{item.service}</span>
                        <span className="drawer-price">{item.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div 
            className="service-item"
            onClick={() => handleServiceClick('milling')}
            onMouseEnter={() => !isMobile && setActiveService('milling')}
            onMouseLeave={() => !isMobile && setActiveService(null)}
          >
            <span className="service-number">02</span>
            <span className="service-name">Фрезерование STL файлов</span>
            {!isMobile && (
              <div className="price-drawer">
                <div className="drawer-content">
                  <div className="drawer-list">
                    {servicesData.milling.priceList.map((item, idx) => (
                      <div key={idx} className="drawer-row">
                        <span className="drawer-service">{item.service}</span>
                        <span className="drawer-price">{item.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div 
            className="service-item"
            onClick={() => handleServiceClick('printing')}
            onMouseEnter={() => !isMobile && setActiveService('printing')}
            onMouseLeave={() => !isMobile && setActiveService(null)}
          >
            <span className="service-number">03</span>
            <span className="service-name">3D печать</span>
            {!isMobile && (
              <div className="price-drawer">
                <div className="drawer-content">
                  <div className="drawer-list">
                    {servicesData.printing.priceList.map((item, idx) => (
                      <div key={idx} className="drawer-row">
                        <span className="drawer-service">{item.service}</span>
                        <span className="drawer-price">{item.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </main>

      {isMobile && (
        <div className={`mobile-price-drawer ${activeService ? 'open' : ''}`}>
          <div className="mobile-drawer-overlay" onClick={handleCloseDrawer}></div>
          <div className="mobile-drawer-content">
            <div className="mobile-drawer-header">
              <span>{getActiveServiceData()?.name}</span>
              <button className="mobile-drawer-close" onClick={handleCloseDrawer}>Закрыть</button>
            </div>
            <div className="mobile-drawer-list">
              {getActiveServiceData()?.priceList.map((item, idx) => (
                <div key={idx} className="mobile-drawer-row">
                  <span className="mobile-drawer-service">{item.service}</span>
                  <span className="mobile-drawer-price">{item.price}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LandingPage;